import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import looppa from 'looppa';
import { CARD } from 'constants/placeholder-events';
import Plugin from 'components/cms-placeholder/plugin';
import { SIZE_DESKTOP, SIZE_MOBILE } from './const';
import { mq } from 'util/dom/mq';
import facetMap from 'util/react/facet';

class SectionRightMany extends PureComponent {
    static propTypes = {
        plugins: PropTypes.array,
        size_class: PropTypes.string,
        isCmsEditModeEnabled: PropTypes.bool,
        type: PropTypes.string.isRequired,
        cms: PropTypes.array,
    };

    static defaultProps = {
        plugins: [],
    };

    state = {
        extendedContent: {},
    };

    onEvent = (eventName, data) => {
        if (eventName === CARD) {
            this.setState({ extendedContent: data });
        }
    };

    /**
     * Add custom data to plugins if so requested by one of the plugins
     * via onEvent
     */
    get extendedPlugins() {
        return this.props.plugins.map(plugin => {
            plugin.content = { ...plugin.content, ...this.state.extendedContent };
            return plugin;
        });
    }

    renderDesktop() {
        const { isCmsEditModeEnabled } = this.props;
        const plugins = this.extendedPlugins;
        const largePlugin = plugins.shift();

        return [
            <div className="cms-section-right-many--col cms-section-right-many--col-left" key="large-plugin">
                <Plugin
                    isCmsEditModeEnabled={isCmsEditModeEnabled}
                    index={0}
                    key={0}
                    onEvent={this.onEvent}
                    parent={this.props}
                    {...largePlugin}
                />
            </div>,
            <div className="cms-section-right-many--col cms-section-right-many--col-right" key="small-plugin">
                {looppa(plugins)((plugin, i) =>
                    <Plugin
                        isCmsEditModeEnabled={isCmsEditModeEnabled}
                        facet={'onboarding'}
                        index={i + 1}
                        onEvent={this.onEvent}
                        parent={this.props}
                        key={i + 1}
                        {...plugin}
                    />
                )}
            </div>,
        ];
    }

    renderMobile() {
        const { isCmsEditModeEnabled } = this.props;
        const plugins = this.extendedPlugins;

        return (
            <div>
                {looppa(plugins)((plugin, i) =>
                    <div className="cms-section-right-many--col" key={i + 1}>
                        <Plugin
                            isCmsEditModeEnabled={isCmsEditModeEnabled}
                            index={i + 1}
                            onEvent={this.onEvent}
                            parent={this.props}
                            {...plugin}
                        />
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { size_class } = this.props;

        let content = null;

        if (size_class === SIZE_DESKTOP && mq('>=lg')) {
            content = this.renderDesktop();
        } else if (size_class === SIZE_MOBILE && mq('<lg')) {
            content = this.renderMobile();
        } else {
            return null;
        }

        return (
            <div
                className={classnames('cms-section-right-many', 'grid grid__base', facetMap(size_class, 'cms-section-right-many'))}>
                <div className="cms-section-right-many--row">
                    {content}
                </div>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        viewportWidth: 'viewport.width',
    }),
    reduxUtils.mapDispatchToProps({}),
)(SectionRightMany);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/section-right-many/index.js